import React from 'react';
import { FormattedMessage } from 'react-intl';

// 시스템 설정 > 관리자 작업 로그 > 로그 목록의 column 정보 
export const DOCUMENT_LIST_COLUMNS = [
    { id: 'createdAt', label: <FormattedMessage id="spike.document.file.date"/>, customClassName: 'left', isSortable: true },
    { id: 'fileName', label: <FormattedMessage id="spike.document.file.name"/>, customClassName: 'center', isSortable: false },
    { id: 'fileSize', label: <FormattedMessage id="spike.document.file.size"/>, customClassName: 'center', isSortable: false },
    { id: 'fileType', label: <FormattedMessage id="spike.document.file.type"/>, customClassName: 'center', isSortable: false },
    { id: 'owner', label: <FormattedMessage id="spike.document.file.owner"/>, customClassName: 'center', isSortable: false },
    { id: 'fileDownload', label: <FormattedMessage id="spike.document.file.download"/>, customClassName: 'center', isSortable: false },
];

// 문서 등록 > 문서저장여부 Radio버튼 정보 
export const FILE_REGISTRATION_SAVE_OPTIONS = [
    { text: <FormattedMessage id="document.file.save.on"/>, value: "on" },
    { text: <FormattedMessage id="document.file.save.off"/>, value: "off" }
];
export const DEFAULT_VALUES_FOR_FILE_REGISTRATION = { save: "off", bucketName: "test" }

//****** 이미지 비식별화 ******//
// 이미지 추출 시의 feature type 
export const IMAGE_FEATURE_TYPES = [
    { text: <FormattedMessage id="document.image.feature.type.document"/>, value: "11" },
    { text: <FormattedMessage id="document.image.feature.type.image"/>, value: "5" }
];

// 이미지에 있는 text의 언어 선택 
export const IMAGE_LANGUAGES = [
    { text: <FormattedMessage id="document.image.languages.ko"/>, value: "ko" },
    { text: <FormattedMessage id="document.image.languages.en"/>, value: "en" }
];

// form의 초기값 
export const DEFAULT_VALUES_FOR_IMAGE_DEIDENTIFICATION = { languages: [] }


//************************************ form (기본값 및 submit전 form value 정리) ************************************//

const _getDefaultValueForDomain = () => ({ defaultDomain: false, virtualDomains: [], mailDomain: '' });
export const getDefaultValueForDomain = _getDefaultValueForDomain();

// formValues값 정리
export function resetFormValues( values, menuName ) {
    let result = {};

    // 관리자 정보 저장
    if( menuName === "domain.admin" ) {
        // 허용 아이피
        if( values.ipType === "all" ) {
            result.authIp = "";
        } else {
            result.authIp = values.allowedIps.join("|");
        }
    } else if( menuName === "domain.company" ) {
        result.name = values.name.trim();

        // 메일 용량 
        if( values.totalMailQuota > 0 ) {
            result.totalMailQuota = values.totalMailQuota * values.mailQuotaUnit;
        } else {
            values.totalMailQuota = 0;
        }
    }

    return result;
}

//************************************ 기타 ************************************//

